import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { VARIABLES } from "../../Constant";
import secureLocalStorage from "react-secure-storage";
import PumpCreateScheduler from "./PumpCreateScheduler";
import PumpEditScheduler from "./PumpEditScheduler";
import PumpSchedulerTable from "./PumpSchedulerTable";
import { StateContext } from "../../Context/StateContext";

const PumpScheduler = (props) => {
  const privileges = secureLocalStorage.getItem("privileges");

  const { setNodeSchedulerData, nodeSchedulerData, schedulerData, setSchedularData } = useContext(StateContext);

  const onChangeSidebar = (section) => {
    props.handleSidebar(section);
  };

  const [isLoading, setIsLoading] = useState(false);

  const [checked, setChecked] = useState(false);
  console.log(checked);

  // particular pin wise scheduler data - to display on table
  // const [schedulerData, setSchedularData] = useState([]);
  // console.log(schedulerData);

  const [weekDays, setWeekDays] = useState([]);
  const [node, setNode] = useState([]);

  // tO ASSIGNED entity value
  const [pumps, setPumps] = useState([
    { value: props.schedularZone.id, label: props.schedularZone.name },
  ]);

  const [editedScheduler, setEditedScheduler] = useState(null);

  const apiSchedulerData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        VARIABLES.url +
          `/api/scheduler-details?entity_id=${props.schedularZone.id}`
      );
      // const res = await axios.get(VARIABLES.url + `/api/scheduler-details`);
      setSchedularData(res.data);
      setIsLoading(false);
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const apiAllSchedulerData = async () => {
    try {
      const res = await axios.get(VARIABLES.url + `/api/scheduler-details`);
      console.log(res.data);
      const filterByNode = res.data.filter(
        (data) => data.entity.node_id === props.schedularZone.node_id
      );
      setNodeSchedulerData(filterByNode);
    } catch (error) {
      console.log(error);
    }
  };

  const apiWeekDaysData = async () => {
    try {
      const res = await axios.get(
        VARIABLES.url + "/api/category-master?type=days"
      );
      setWeekDays(
        res.data.map((day) => ({
          value: day.name,
          label: day.name,
        }))
      );
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const apiNodeData = async () => {
    try {
      const res = await axios.get(
        VARIABLES.url + "/api/category-master?type=node"
      );
      console.log(res.data);
      setNode(
        res.data.map((day) => ({
          value: day.name,
          label: day.name,
          is_in_progress: day.is_in_progress,
        }))
      );
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const editSchedule = (id) => {
    const getEditedScheduler = schedulerData.find((data) => {
      return data.id === id;
    });
    console.log(getEditedScheduler);
    setEditedScheduler(getEditedScheduler);
  };

  const nodeStatus = node?.find((data) => {
    return data.label === props.schedularZone.node_id;
  });
  console.log(nodeStatus);

  useEffect(() => {
    apiAllSchedulerData();
    apiSchedulerData();
    apiWeekDaysData();
    apiNodeData();
  }, []);

  return (
    <>
      {privileges.includes("back_pump") && (
        <div className="nk-block-head" style={{ paddingBottom: "1.25rem" }}>
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <a
                href="javascript:void(0)"
                className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                onClick={() => onChangeSidebar("pump_details")}
              >
                <em className="icon ni ni-arrow-left"></em>
                <span>Back</span>
              </a>
              <a
                href="javascript:void(0)"
                className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                onClick={() => onChangeSidebar("pump_details")}
              >
                <em className="icon ni ni-arrow-left"></em>
              </a>
            </div>
            {nodeStatus?.is_in_progress && <div className="nk-block-head-content">
              <button
                  type="button"
                  className="btn btn-sm btn-danger shake-btn"
                  data-bs-toggle="tooltip" data-bs-placement="top" title="Server and Controller are not in sync. Please click update button."
                >
                  <em class="icon ni ni-alert"></em>
                  <span>Need Attension</span>
                </button>
            </div>}
          </div>
        </div>
      )}

      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title page-title">
              {props.schedularZone.name}
            </h4>
          </div>
          <div class="nk-block-head-content">
            <div className="col-auto d-flex w-sm-100">
              {privileges.includes("particular_pump_logs") && (
                <button
                  type="button"
                  className="btn btn-sm btn-primary me-3"
                  onClick={() => onChangeSidebar("particular pump feedback")}
                >
                  <span>Power Washer Switching Log</span>
                </button>
              )}
              {privileges.includes("add_pump_scheduler") && (
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#setSchedule"
                >
                  <em class="icon ni ni-plus"></em>
                  <span>Scheduler Timer</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <PumpSchedulerTable
        schedularZone={props.schedularZone}
        isLoading={isLoading}
        editSchedule={editSchedule}
        schedulerData={schedulerData}
        nodeSchedulerData={nodeSchedulerData}
        setSchedularData={setSchedularData}
        setNodeSchedulerData={setNodeSchedulerData}
      />

      <PumpCreateScheduler
        schedularZone={props.schedularZone}
        apiSchedulerData={apiSchedulerData}
        pumps={pumps}
        weekDays={weekDays}
        setSchedularData={setSchedularData}
        setNodeSchedulerData={setNodeSchedulerData}
      />

      <PumpEditScheduler
        schedularZone={props.schedularZone}
        editedScheduler={editedScheduler}
        apiSchedulerData={apiSchedulerData}
        pumps={pumps}
        weekDays={weekDays}
        setSchedularData={setSchedularData}
        setNodeSchedulerData={setNodeSchedulerData}
      />
    </>
  );
};

export default PumpScheduler;
